<template>
  <!-- 律师说法详情页 -->
  <div class="articimdet">
    <div class="w12 between">
      <lvbreadcrumb class="speltmbx" :tolist="tolist" />
      <div class="articdetlef">
        <articzw :articinfo="articinfo" />
        <articgolawer :list="adetlist" />
      </div>
      <div class="articdetrig">
        <detlawbrinfo class="bgff" />
        <detrecomvideo class="bgff mt30" :list="tjvolist" />
      </div>
    </div>
  </div>
</template>

<script>
import articzw from "./child/articzw";
import articgolawer from "./child/articgolawer";
import detlawbrinfo from "./components/detlawbrinfo";
import detrecomvideo from "./components/detrecomvideo";
import lvbreadcrumb from "components/content/lvbreadcrumb/lvbreadcrumb";

export default {
  components: {
    articzw,
    articgolawer,
    detlawbrinfo,
    detrecomvideo,
    lvbreadcrumb,
  },
  data: () => ({
   
    articinId:0,
    articinfo:{},
    adetlist:[],
    tjvolist:[],
  }),
  computed: {
    tolist() {
      return [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "律师解答",
          path: "/laws/articleclaim",
        },
        {
          name: this.articinfo.title || '',
        },
      ];
    },
  },
  beforeMount() {
    this.articinId = this.$route.query.articinId
    this.getarticinfo()
    this.getarticlist()
    this.getvilist()
  },
  methods:{
    getarticinfo(){
      let data = {
        id : this.articinId
      }
      this.$http.laws.getarticcontent(data)
      .then((res) => {
        this.articinfo = res.data
      })
    },
    
    getarticlist() {
      let data = {
        limit: 4,
          page: 1,
          order: "hot",
      };
      this.$http.laws.getarticlist(data).then((res) => {
        this.adetlist = res.data.data;
      });
    },
    
    getvilist() {
      this.$http.laws
        .getvideolist({
          limit: 5,
          page: 1,
          order: "hot",
        })
        .then((res) => {
          this.tjvolist = res.data.data;
        });
    },
  },
  
  watch: {
    $route(to, from) {
    this.articinId = this.$route.query.articinId
    this.getarticinfo()
    this.getarticlist()
    this.getvilist()
    },
  },
};
</script>

<style lang="scss" scoped>
.articimdet {
  background-color: #f8f8f8;
  .w12 {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    align-items: flex-start;
    position: relative;
    .bgff {
      background: #ffffff;
    }
    .articdetlef {
      width: 856px;
      background: #ffffff;
    }
    .articdetrig {
      width: 314px;
    }
  }
  .speltmbx {
    position: absolute;
    top: 20px;
    left: 0;
  }
}
</style>